export const NOTIFY = 'NOTIFY';

export const notify = (message, error = false) => dispatch => {
  const id = new Date().getTime();

  dispatch({
    type: NOTIFY,
    id,
    message,
    error,
  });
};



// WEBPACK FOOTER //
// ./src/actions/notifications.js